import { DrivingSchool, drivingSchoolsProvider } from "../providers/drivingSchoolsProvider";
import { useCurrentDrivingSchoolId } from "./useCurrentDrivingSchoolId";

export function useCurrentDrivingSchool(): DrivingSchool {
  const drivingSchoolId = useCurrentDrivingSchoolId();
  const drivingSchool = drivingSchoolsProvider.getOneFromCache(drivingSchoolId);
  if (!drivingSchool) {
    throw new Error(`DrivingSchool ${drivingSchoolId} not in cache.`);
  }
  return drivingSchool;
}
